import { getPanelAccessToken } from './apiAuthProvider';

const getApiUrl = () => {
  const base = process.env.REACT_APP_API_URL ?? 'http://localhost:3001';
  return base.replace(/\/$/, '');
};

export const fetchPendingReviewSummary = async () => {
  const token = getPanelAccessToken();
  if (!token) return { total: 0, items: [] };

  const res = await fetch(`${getApiUrl()}/events/pending-review/summary`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    if (res.status === 403) return { total: 0, items: [] };
    throw new Error(`Pending summary failed (${res.status})`);
  }
  return res.json();
};

export const exchangeMagicLoginToken = async (token) => {
  const res = await fetch(`${getApiUrl()}/auth/panel/magic-login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(
      data?.message || 'Bağlantı geçersiz veya süresi dolmuş',
    );
  }
  return data;
};
